import React from 'react';
import classNames from "classnames";
import styles from "../../styles/standings-widget.module.scss";
import {EntityLogo} from "../../../../core/components/logos/entity-logo";
import {Link} from "../../../../core/components/link/link";

export const StandingsWidgetPointsDeductionsCompetitor = ({point}) => {
  const {competitor} = point;

  const linkProps = {
    className: classNames(styles.points_deductions_competitor),
    model: point.competitor.linkModel,
  }

  const entityLogoProps = {
    entity: point.competitor,
    className: classNames(styles.points_deductions_competitor_logo),
    width: 32,
    height: 32
  }

  return <Link {...linkProps}>
    <EntityLogo {...entityLogoProps}/>
    {competitor.name}
  </Link>
};